export default __webpack_public_path__ + "static/simple-line-76b60ce65cd6b92b7b3f112fae460024.png";